import React from "react";
import HeroCarousel from "@/components/home/HeroCarousel";
import WhatBringsYouHere from "@/components/home/WhatBringsYouHere";
import TopBrands from "@/components/home/TopBrands";
import FeaturedCategories from "@/components/home/FeaturedCategories";
import OffersOfDay from "@/components/home/OffersOfDay";
import Refurbished from "@/components/home/Refurbished";
import BulkBuy from "@/components/home/BulkBuy";
import USPStrip from "@/components/home/USPStrip";
import PromoBanner from "@/components/home/PromoBanner";

export default function Home() {
  return (
    <main data-testid="home-page" className="pb-16">
      <HeroCarousel />
      <USPStrip />
      <WhatBringsYouHere />
      <TopBrands />
      <FeaturedCategories />
      <OffersOfDay />
      <Refurbished />
      <BulkBuy />
      <PromoBanner />
    </main>
  );
}
